<app-popup>
    <div class="inner">
        <span class="default-cross" (click)="onClose()"></span>
        <div class="title">{{typeAction == 'add' ? 'Запрос услуги' : 'Отмена услуги'}}</div>


        <form class="form" [formGroup]="form">

            <!--      <div class="row">-->
            <div class="text-description">
                {{typeAction == 'add' ?
                'Вы можете написать, какая услуга Вам необходима, либо просто отправить запрос, нажав на кнопку "Отправить запрос", и менеджер свяжется с Вами.' :
                'Вы можете написать, какую услугу Вы хотите отменить, либо просто отправить запрос, нажав на кнопку "Отправить запрос", и менеджер свяжется с Вами.'}}
            </div>
            <!--      </div>-->

            <!--<div class="row">
              <div class="item"
                   [class.error]="serviceCtrl.touched && serviceCtrl.errors || (serviceCtrl.errors && submitting)">
                <label for="service" class="label">Тип услуги</label>
                       (change)="serviceChanged($event.target.value)"
                <select class="select" id="service" [formControl]="serviceCtrl"
                >
                  <option disabled value="" selected hidden>Тип услуги</option>
                  <option class="option" *ngFor="let item of services" [value]="item.id">{{item.text}}</option>
                </select>
              </div>
            </div>-->

            <div class="row">
                <div class="item"
                     [class.error]="requestMessageCtrl.touched && requestMessageCtrl.errors || (requestMessageCtrl.errors && submitting)">
                    <!--        <label for="oldPassword" class="label required">старый пароль</label>-->
                    <textarea class="input" id="oldPassword" [formControl]="requestMessageCtrl"
                              placeholder="  Вы можете описать запрос здесь"> </textarea>
                </div>
            </div>


        </form>

        <div class="buttons-wrapper">
            <button class="button blue-btn" (click)="onClose()">
                Отмена
            </button>
            <button class="button red-btn" (click)="onSubmit()"
                    [disabled]="submitPressed || (!form.valid && submitting) ">
                Отправить Запрос
            </button>
        </div>
    </div>
</app-popup>
